import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { Row, Col } from "reactstrap";
import { Container } from "./style";

import { Creators as SubscriptionCreators } from "../../../store/ducks/subscription";
import { Creators as CreditCardCreators } from "../../../store/ducks/creditCard";
import CreditCard from "../../../components/CreditCard";

class Cards extends Component {
  static propTypes = {
    subscription: PropTypes.shape.isRequired,
    subscriptionLoading: PropTypes.bool.isRequired
  };

  state = {
    adding: false
  };

  newCrediCard = creditCard => {
    this.props.subscription({
      ...creditCard,
      newCard: true
    });
  };

  componentWillReceiveProps = () => {
    if (window.location.search.includes("added=true")) {
      this.setState({ adding: false });
    }
  };

  render() {
    const { subscription_data, subscriptionLoading } = this.props;
    const { adding } = this.state;
    return (
      <Container>
        <h1 className="title-underline">Meus cartões</h1>
        <Row>
          <Col md={12} lg={6}>
            {!subscriptionLoading && !adding && (
              <CreditCard
                editable={adding}
                {...subscription_data.credit_card}
              />
            )}
            {adding && (
              <CreditCard
                editable={adding}
                className="left"
                sandCard={this.newCrediCard}
              />
            )}
            <button
              type="button"
              className={`btn btn-success ${adding && "btn-cancel"} btn-block`}
              onClick={() => this.setState({ adding: !adding })}
            >
              {adding ? "Cancelar" : "Trocar Cartão"}
            </button>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  subscriptionLoading: state.subscription.subscription.loading,
  subscription_data: state.subscription.subscription.data
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...SubscriptionCreators,
      ...CreditCardCreators
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Cards);



// WEBPACK FOOTER //
// ./src/pages/admin/cards/index.js